import { formatCompletedTime } from "../../intelligence/intelligenceLabels";
import SourceHealthBadge from "../SourceHealthBadge";
import StatusBadge from "../../intelligence/StatusBadge";
import { trustScoreTone } from "../../../../utils/sourceTrustLabels";

function formatDuration(ms) {
  if (ms == null || Number.isNaN(ms)) {
    return "—";
  }

  if (ms < 1000) {
    return `${ms}ms`;
  }

  const seconds = Math.round(ms / 1000);
  if (seconds < 60) {
    return `${seconds}s`;
  }

  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return `${minutes}m ${remainder}s`;
}

function mapRunStatusForBadge(status) {
  if (!status) {
    return "unknown";
  }

  return String(status).toLowerCase();
}

const RealEstateRunsModal = ({
  source,
  runs,
  isOpen,
  isLoading,
  errorMessage,
  onClose,
  onViewDetails,
}) => {
  if (!isOpen || !source) {
    return null;
  }

  return (
    <div className="admin-re-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="admin-re-modal panel-card admin-re-modal--wide"
        role="dialog"
        aria-labelledby="runs-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="admin-re-modal-header">
          <div>
            <p className="eyebrow">Run history</p>
            <h2 id="runs-modal-title">{source.displayName}</h2>
            <p className="muted admin-re-source-code">{source.sourceKey}</p>
          </div>
          <button type="button" className="midpoint-share-button" onClick={onClose}>
            Close
          </button>
        </header>

        <div className="admin-re-modal-body">
          {isLoading ? <p className="muted">Loading run history…</p> : null}
          {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}

          {!isLoading && !errorMessage && !runs?.length ? (
            <p className="muted">No ingestion runs recorded yet.</p>
          ) : null}

          {!isLoading && runs?.length ? (
            <div className="admin-data-health-table-wrap">
              <table className="admin-data-health-table admin-re-runs-table">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Trigger</th>
                    <th>Started</th>
                    <th>Duration</th>
                    <th>Found</th>
                    <th>Created</th>
                    <th>Updated</th>
                    <th>Deactivated</th>
                    <th>Review</th>
                    <th>Errors</th>
                    <th>Trust after</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {runs.map((run) => (
                    <tr key={run.runId}>
                      <td>
                        <SourceHealthBadge status={mapRunStatusForBadge(run.status)} />
                      </td>
                      <td>{run.triggeredBy || "—"}</td>
                      <td>{formatCompletedTime(run.startedAt)}</td>
                      <td>{formatDuration(run.durationMs)}</td>
                      <td>{run.recordsFound}</td>
                      <td>{run.recordsCreated}</td>
                      <td>{run.recordsUpdated}</td>
                      <td>{run.recordsDeactivated}</td>
                      <td>{run.recordsFlaggedForReview}</td>
                      <td className="admin-re-error-cell" title={run.errorMessage || ""}>
                        {run.errorCount > 0 || run.errorMessage
                          ? run.errorCount || "Yes"
                          : "—"}
                      </td>
                      <td>
                        {run.trustRecalculationStatus === "FAILED" ? (
                          <span className="muted" title={run.trustRecalculationError || ""}>
                            Failed
                          </span>
                        ) : run.trustLabelAfterRun ? (
                          <StatusBadge
                            label={`${run.trustLabelAfterRun} ${run.trustScoreAfterRun ?? ""}`.trim()}
                            tone={trustScoreTone(run.trustScoreAfterRun)}
                          />
                        ) : (
                          <span className="muted">—</span>
                        )}
                      </td>
                      <td>
                        <button
                          type="button"
                          className="midpoint-share-button admin-re-btn-link"
                          onClick={() => onViewDetails?.(run)}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default RealEstateRunsModal;
